import React, {useState, useEffect, useRef, useCallback }        from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {useActionModal}                     from "components/Covers/confirmAction";
import {useInfoMsgModal}                    from "components/Covers/infoMessageModal";
import {useToastMessage}                    from "components/Covers/toastMessage";
import {InputGeneral}                       from "components/Field/field";
import {BtnCloseAction}                     from "components/Buttons/Close/BtnClose";
import MainStyle                            from "components/UI/main.module.scss";
import { 
    getOptionLists,
    getOptionListByID,
    updateOptionList,
    deleteOptionList,
    updateOptionListItem,
    deleteOptionListItem 
}                                           from "./optionListService";
// BEGIN AG AGRID
import {AgGridReact}                        from "ag-grid-react";
import {AllCommunityModule,ModuleRegistry}  from 'ag-grid-community';
import {AG_GRID_LOCALE_BR}                  from '@ag-grid-community/locale';
import { q3x_FunData, 
         q3z_FunNumbers,
         DefaultLoadingLogo,
         DavidCopperfield,
         Heimdall,
         GetLabel,
         GetAppLang,
         SetLastFeature }                   from "Utilities/utils"

/*  Drag and drops libs  */
import { DndProvider, useDrag, useDrop }    from 'react-dnd';
import { HTML5Backend }                     from 'react-dnd-html5-backend';
import { TouchBackend }                     from 'react-dnd-touch-backend';

import {DisplayGridDatetime}                from "components/Date/date";
import { useNavigate }                      from "react-router-dom";

const getDndBackend = () => {
    const isTouchDevice =
      typeof window !== 'undefined' &&
      ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  
    return {
      backend: isTouchDevice ? TouchBackend : HTML5Backend,
      options: isTouchDevice ? { enableMouseEvents: true } : undefined,
    };
};

let appLang = null; 

let blank_option_list_obj = {
    'OPTION_LIST_ID': 0,
    'OPTION_LIST_DESC': "",
    'STATUS_ID': 1,
    'WEIGHT': "N",
    'LANG_PT': "Y",
    'LANG_EN': "N",
    'LANG_ES': "N",
    'ITEMS_LIST': []
};
let blank_option_list_item_obj = {  
    'OPTION_LIST_ITEM_ID': 0,
    'OPTION_LIST_ITEM_ORDER': 0,
    'LANG_PT_DESC': "",
    'LANG_EN_DESC': "",
    'LANG_ES_DESC': "",
    'OPTION_VALUE': 0.0,
    'IsEditing': true,
    'IsLoading': false,
};




const OptionItem =  React.memo(({ mainProp, prop, setProp, index, moveItem, onDelete }) => {
    const { showLoader, hideLoader }                            = useLoader();                      // Control over the loader
    const { showInfoMessage   }                                 = useInfoMsgModal();                // Modal message control 
    const { showActionMessage }                                 = useActionModal();                 // Modal message + action control     
    const { showToastMessage  }                                 = useToastMessage();                // Toast message display
    const itemRef                                               = useRef(null);

    const handleInputChange      = (field, value) => {
        setProp(index, { [field]: value });
    };

    function validateNumber(ns) {
        try {
            let casted = Number.parseFloat(ns);
            if (!isNaN(casted)) {
                let n = casted.toFixed(2);
                handleInputChange("OPTION_VALUE", n);
                return true;
            } else {
                handleInputChange("OPTION_VALUE", Number.parseFloat(0).toFixed(2));
                return false;
            }
        } catch (e) {
            handleInputChange("OPTION_VALUE", Number.parseFloat(0).toFixed(2));
            return false;
        }
    }

    const handleEdit             = () => {
        if (!prop.IsEditing) {
            handleInputChange("IsEditing", true);
        }
        else {
            handleInputChange("IsEditing", false);
            saveItem();
        }
    };

    const handleDelete = () => {
        if(mainProp.ITEMS_LIST.length === 1 && prop.OPTION_LIST_ITEM_ID != 0) {
            showInfoMessage({'header': GetLabel(appLang, 54), 'message': <>{GetLabel(appLang, 169)}</>});            
            return;
        }
        if (prop.OPTION_LIST_ITEM_ID == 0) {
            deleteItem(mainProp.OPTION_LIST_ID, prop.OPTION_LIST_ITEM_ID, index);
        }
        else {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 58)}<br/>{GetLabel(appLang, 59)}</> },
                { confirm_action: () => deleteItem(mainProp.OPTION_LIST_ID, prop.OPTION_LIST_ITEM_ID, index)}
            );
            return;
        }
    };

    const saveItem = async () => {
        // BeginV
        if (mainProp.LANG_PT === "Y" && prop.LANG_PT_DESC === "") {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 70)}</>});
            handleInputChange("IsEditing", true);
            return;
        }
        else if (mainProp.LANG_EN === "Y" && prop.LANG_EN_DESC === "") {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 171)}</>});
            handleInputChange("IsEditing", true);
            return;
        }
        else if (mainProp.LANG_ES === "Y" && prop.LANG_ES_DESC === "") {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 172)}</>});
            handleInputChange("IsEditing", true);
            return;
        }
        else if (!validateNumber(prop.OPTION_VALUE)) {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 173)}</>});
            handleInputChange("IsEditing", true);
            return;
        }
        // EndV
        
        let sendedData = {
            OPTION_LIST_ID:         mainProp.OPTION_LIST_ID,
            OPTION_LIST_ITEM_ID:    prop.OPTION_LIST_ITEM_ID,
            OPTION_LIST_ITEM_ORDER: prop.OPTION_LIST_ITEM_ORDER,
            LANG_PT_DESC:           prop.LANG_PT_DESC,
            LANG_EN_DESC:           prop.LANG_EN_DESC,
            LANG_ES_DESC:           prop.LANG_ES_DESC,
            OPTION_VALUE:           prop.OPTION_VALUE
        };

        if (prop.OPTION_LIST_ITEM_ID === 0 ){
            if (mainProp.OPTION_LIST_ID === 0) {
                showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 174)}</>});
                handleInputChange("IsEditing", true);
                return;
            }
            handleInputChange("IsLoading", true);
            let data = await updateOptionListItem(sendedData);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    handleInputChange("OPTION_LIST_ITEM_ID", parseInt(data.OPTION_LIST_ITEM_ID));
                    handleInputChange("IsLoading", false);
                }
                else {
                    handleInputChange("IsLoading", false);
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        }
        else {
            handleInputChange("IsLoading", true);
            let data = await updateOptionListItem(sendedData);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    handleInputChange("OPTION_LIST_ITEM_ID", parseInt(data.OPTION_LIST_ITEM_ID));
                    handleInputChange("IsLoading", false);
                }
                else {
                    handleInputChange("IsLoading", false);
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }

        }
        
    };

    async function deleteItem (list_id, item_id, index) {
        if (item_id === 0 ){
            onDelete(item_id, index);
        }
        else {
            handleInputChange("IsLoading", true);
            let data = await deleteOptionListItem(list_id, item_id);
            if (data) {
                if (data?.status?.statusCode === 0) {
                    let tmp         = mainProp;
                    tmp.ITEMS_LIST  = tmp.ITEMS_LIST.filter(item => item.OPTION_LIST_ITEM_ID !== item_id);
                    // Save the new order of item indexes
                    showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                    let updateRequest = await updateOptionList(tmp);
                    if (updateRequest?.status?.statusCode === 0) {
                        onDelete(item_id, index);
                        hideLoader();
                    }
                    else {
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': updateRequest.status.message});
                        hideLoader();
                    }
                    
                }
                else {
                    handleInputChange("IsLoading", false);
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        }
    }

    const [{ handlerId }, drop]  = useDrop(
        {
        accept: 'card',        
        collect(monitor) {
          return {
            handlerId: monitor.getHandlerId(),
          }
        },
        hover(item, monitor) {
            if (!itemRef.current) {
              return;
            }
          
            const dragIndex = item.index;
            const hoverIndex = index;
          
            // Do nothing if dragging over itself
            if (dragIndex === hoverIndex) {
              return;
            }
          
            // Get bounding rectangle
            const hoverBoundingRect = itemRef.current.getBoundingClientRect();        
          
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
          
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
          
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
          
            // Only perform the move when the mouse has crossed half of the item's height
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
              return;
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
              return;
            }
          
            // Time to actually perform the action
            moveItem(dragIndex, hoverIndex);
          
            // Note: mutate the monitor item to update the index
            item.index = hoverIndex;
          }
    });
    
    const [{ isDragging }, drag] = useDrag({
        type: 'card',
        item: () => {
          const id = prop.OPTION_LIST_ITEM_ORDER;
          return { id, index };
        },
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
    });
    const opacity                = isDragging ? 0.4 : 1;

    drag(drop(itemRef));

    return (
        <>
            <div
                data-handler-id={handlerId}
                ref={itemRef}
                style={{ opacity, cursor: 'grab' }}
                className={[MainStyle.row, MainStyle.align_items_center, MainStyle.mx_3, MainStyle.py_1, MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>
                    {/*         Loading Icon                */}
                        {
                            prop.IsLoading ? 
                                <div style={{zIndex: '1'}} className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.small_loading_circle].join(" ")}/>
                                </div>
                            :
                                null
                    }
                    {/*         Item Position                */
                        <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                            <span className={[  
                                                MainStyle.fs_7,
                                                MainStyle.text_body,
                                                MainStyle.fw_semibold].join(" ")}>
                                { index  + 1 }
                            </span>                                
                        </div>
                    } 

                    {/*         Items Description PT        */}
                        {
                            mainProp.LANG_PT == "Y" ?
                                <div className={MainStyle.col_lg}>
                                    <div className={MainStyle.m_2}>
                                        <span className={[  MainStyle.fs_6,
                                                            MainStyle.text_body,
                                                            MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 175)}
                                        </span>
                                        {
                                            prop.IsEditing ?
                                                <InputGeneral 
                                                    value={prop.LANG_PT_DESC || ''}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleInputChange("LANG_PT_DESC", q3x_FunData(event.target.value))}
                                                    placeholder={GetLabel(appLang, 176)}
                                                    maxLength={50}
                                                />
                                            :
                                                <p className={[  MainStyle.fs_7, MainStyle.text_body].join(" ")}>        
                                                    {prop.LANG_PT_DESC || ''}
                                                </p>
                                        }
                                    </div>
                                </div>
                            :
                                null
                        }                        
                    {/*         Items Description EN        */}
                        {
                            mainProp.LANG_EN == "Y" ?
                                <div className={MainStyle.col_lg}>
                                    <div className={MainStyle.m_2}>
                                        <span className={[  MainStyle.fs_6,
                                                            MainStyle.text_body,
                                                            MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 177)}
                                        </span>
                                        {
                                            prop.IsEditing ?
                                                <InputGeneral 
                                                    value={prop.LANG_EN_DESC || ''}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleInputChange("LANG_EN_DESC", q3x_FunData(event.target.value))}
                                                    placeholder={GetLabel(appLang, 176)}
                                                    maxLength={50}
                                                />
                                            :
                                                <p className={[  MainStyle.fs_7, MainStyle.text_body].join(" ")}>
                                                    {prop.LANG_EN_DESC || ''}
                                                </p>
                                        }
                                    </div>
                                </div>
                            :
                                null
                        }
                    {/*         Items Description ES        */}
                        {
                            mainProp.LANG_ES == "Y" ?
                                <div className={MainStyle.col_lg}>
                                    <div className={MainStyle.m_2}>
                                        <span className={[  MainStyle.fs_6,
                                                            MainStyle.text_body,
                                                            MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 178)}
                                        </span>
                                        {
                                            prop.IsEditing ?
                                                <InputGeneral 
                                                    value={prop.LANG_ES_DESC || ''}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleInputChange("LANG_ES_DESC", q3x_FunData(event.target.value))}
                                                    placeholder={GetLabel(appLang, 176)}
                                                    maxLength={50}
                                                />
                                            :
                                                <p className={[  MainStyle.fs_7, MainStyle.text_body].join(" ")}>
                                                    {prop.LANG_ES_DESC || ''}
                                                </p>

                                        }
                                    </div>
                                </div>
                            :
                                null
                        }
                    {/*         Items Value                 */}
                        {
                            mainProp.WEIGHT == "Y" ?
                                <div className={MainStyle.col_lg}>
                                    <div className={MainStyle.m_2}>
                                        <span className={[  MainStyle.fs_6,
                                                            MainStyle.text_body,
                                                            MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 179)}
                                        </span>
                                        {
                                            prop.IsEditing ?
                                                <InputGeneral 
                                                    defaultValue={0.0}
                                                    value={prop.OPTION_VALUE}
                                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                                    onChange={(event) => handleInputChange("OPTION_VALUE", q3z_FunNumbers(event.target.value))}
                                                    placeholder={GetLabel(appLang, 179)}
                                                    maxLength={10}
                                                />
                                            :
                                                <p className={[  MainStyle.fs_7, MainStyle.text_body].join(" ")}>
                                                    {prop.OPTION_VALUE}
                                                </p>
                                        }
                                    </div>
                                </div>
                            :
                                null
                        }                                         
                    {/*         Ico Edit                    */}
                    <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            {
                                prop.IsEditing ? 
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                        <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                        </svg>
                                    </div>
                                :
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                                        </svg>
                                    </div>
                            }
                        </div>
                    </div>
                    {/*         Ico Trash                   */}
                    <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <div 
                                onClick={() => {handleDelete()}}
                                className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    {/*         Ico Arrow Draggable         */}
                    <div className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <div 
                                className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                    <path d="M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3l0 293.5L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7l0-293.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"/>
                                </svg>
                            </div>
                        </div>                                            
                    </div>
            </div>
        </>
    );
});

const OptionList = ({ mainObject, setMainObject }) => {
    const { backend, options } = getDndBackend();

    const addNewItem    = () => {
        // Create a new object
        const newObject = {
            ...blank_option_list_item_obj, // Copy the template            
            OPTION_LIST_ITEM_ID: 0,
            OPTION_LIST_ITEM_ORDER: mainObject.ITEMS_LIST.length + 1,
            LANG_PT_DESC: "",
            LANG_EN_DESC: "",
            LANG_ES_DESC: "",
            OPTION_VALUE: 0.0,
            IsEditing: true,
        };
    
        // Update state correctly by creating a new array
        setMainObject(prevState => ({
            ...prevState,
            ITEMS_LIST: [...prevState.ITEMS_LIST, newObject]
        }));
    };

    const setItem       = useCallback((itemIndex, updatedFields) => {
        setMainObject(prev => {
          const newItems = [...prev.ITEMS_LIST];
          newItems[itemIndex] = {
            ...newItems[itemIndex],
            ...updatedFields
          };
          return {
            ...prev,
            ITEMS_LIST: newItems
          };
        });
    }, []);

    const moveItem      = useCallback((dragOrder, hoverOrder) => {
        setMainObject(prevState => {
            const updatedItems = [...prevState.ITEMS_LIST];
    
            // Directly use dragOrder and hoverOrder as array indices
            const dragIndex = dragOrder;
            const hoverIndex = hoverOrder;
    
            if (dragIndex === -1 || hoverIndex === -1 || dragIndex === hoverIndex) {
                return prevState;
            }
    
            // Remove the dragged item
            const [movedItem] = updatedItems.splice(dragIndex, 1);
    
            // Insert it at the new position
            updatedItems.splice(hoverIndex, 0, movedItem);
    
            // After moving, fix all OPTION_LIST_ITEM_ORDER to match the new array order
            const reorderedItems = updatedItems.map((item, index) => ({
                ...item,
                OPTION_LIST_ITEM_ORDER: index + 1, // 0-based order now, matching array index
            }));
    
            return {
                ...prevState,
                ITEMS_LIST: reorderedItems,
            };
        });
    }, []);

    function reorderItems () {
        setMainObject(prevState => {
            const reorderedItems = prevState.ITEMS_LIST.map((item, index) => ({
                ...item,
                OPTION_LIST_ITEM_ORDER: index + 1, // 0-based order now, matching array index
                IsEditing: true,
            }));
        
            return {
                ...prevState,
                ITEMS_LIST: reorderedItems,
            };
        });
    }
    
    function handleItemDelete(item_id, item_position) {
        if (item_id !== 0) {
            // Delete by ID
            setMainObject(prevState => {
                const updatedItems = prevState.ITEMS_LIST.filter(item => item.OPTION_LIST_ITEM_ID !== item_id);
    
                const reorderedItems = updatedItems.map((item, idx) => ({
                    ...item,
                    OPTION_LIST_ITEM_ORDER: idx,
                }));
    
                return {
                    ...prevState,
                    ITEMS_LIST: reorderedItems,
                };
            });
            reorderItems();
        } else {
            // Delete by position
            setMainObject(prevState => {
                const updatedItems = prevState.ITEMS_LIST.filter(item => item.OPTION_LIST_ITEM_ORDER -1 !== item_position);
    
                const reorderedItems = updatedItems.map((item, idx) => ({
                    ...item,
                    OPTION_LIST_ITEM_ORDER: idx,
                }));
    
                return {
                    ...prevState,
                    ITEMS_LIST: reorderedItems,
                };
            });
            reorderItems();
        }
    }

    const renderItem    = useCallback((mainProp, prop, setProp, index, moveItem) => {
        const itemKey = prop.OPTION_LIST_ITEM_ID === 0 ? 
            `temp-${prop.OPTION_LIST_ITEM_ORDER}` // Use order as a temporary unique identifier
        : 
            prop.OPTION_LIST_ITEM_ID;           // Use the stable ID when available
        return (
            <OptionItem
                key={itemKey}
                index={index}
                id={index}
                prop={prop}
                setProp={setProp}
                mainProp={mainProp}
                moveItem={moveItem}
                onDelete={handleItemDelete}
            />
        );
    }, []);

    return (
        <>
            <DndProvider backend={backend} options={options}>
            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg_8}>
                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                        <span className={[MainStyle.fs_6,
                                            MainStyle.text_body,
                                            MainStyle.fw_semibold
                                        ].join(" ")}
                        >
                            {GetLabel(appLang, 180)}:
                        </span>
                    </div>
                </div>
                <div className={MainStyle.col_lg_2}>
                    <div className={MainStyle.mx_3}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_blue, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_7,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={addNewItem}
                        >
                            {GetLabel(appLang, 181)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_1}/>
            </div>
            
            {/*         Some spacing         */}
            <div className={MainStyle.py_3}/>
            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg_10}>

                    <div className={MainStyle.my_3}>
                        {
                            <div>
                                {
                                    mainObject.ITEMS_LIST.map((item, i) => renderItem(mainObject, 
                                                                                      item, 
                                                                                      setItem, 
                                                                                      i, 
                                                                                      moveItem))
                                }
                            </div>
                        }
                    </div>



                </div>

                <div className={MainStyle.col_lg_1}/>
            </div>
            </DndProvider>
        </>
    );

};

const OptionListEditPanel = ({setProps, data}) => {
    const { showLoader, hideLoader }                            = useLoader();                      // Control over the loader
    const { showInfoMessage }                                   = useInfoMsgModal();                // Modal message control 
    const { showActionMessage }                                 = useActionModal();                 // Modal message + action control     
    const { showToastMessage            }                       = useToastMessage();                // Toast message display
    const [optionListObj,   setOptionListObj]                   = useState(blank_option_list_obj);  // Option List object
    const [listLoading,     setListLoading]                     = useState(false);

    function validateRecord(obj) {
        let passed = true;
        if (obj.OPTION_LIST_DESC === " "){
            passed = false;
        }
        else if (obj.LANG_PT === "N" && obj.LANG_EN === "N" && obj.LANG_ES === "N") {
            passed = false;
        }
        else if (obj.ITEMS_LIST.length === 0) {
            passed = false;
        }
        for (var i = 0; i < obj.ITEMS_LIST.length; i ++) {
            if (!passed) {
                break;
            }
            else if (obj.LANG_PT === "Y" && obj.ITEMS_LIST[i].LANG_PT_DESC === "") {
                passed = false;
            }
            else if (obj.LANG_EN === "Y" && obj.ITEMS_LIST[i].LANG_EN_DESC === "") {
                passed = false;
            }
            else if (obj.LANG_ES === "Y" && obj.ITEMS_LIST[i].LANG_ES_DESC === "") {
                passed = false;
            }
        }
        return (passed);
    }

    const handleExit = () => {
        setProps({ setScreen: 1, data: blank_option_list_obj });
    };

    const BtnExit = () => {
        showActionMessage(
          { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 102)}<br/>{GetLabel(appLang, 103)}</> },
          { confirm_action: () => handleExit()}
        );
    };    

    const handleSave = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData    = await updateOptionList(optionListObj);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                //  Update every single state of object in the UI
                let updatedItems = optionListObj.ITEMS_LIST.map(item => ({
                    ...item,
                    IsEditing: false
                }));
                handleChange({ ITEMS_LIST: updatedItems });

                hideLoader();
                showToastMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 106)});
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const handleDelete = async () => {
        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
        let fetchedData = await deleteOptionList(optionListObj.OPTION_LIST_ID);
        if (fetchedData) {
            if (fetchedData?.status?.statusCode == 0) {
                hideLoader();
                setProps({ setScreen: 1, data: blank_option_list_obj });   
            }
            else {
                hideLoader();
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
            }
        }
    };

    const SaveList = async () => {
        if (optionListObj.OPTION_LIST_DESC === "") {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 182)}</>});
            return;
        }
        setListLoading(true);
        let sendedData = {
            OPTION_LIST_ID:   optionListObj.OPTION_LIST_ID,
            OPTION_LIST_DESC: optionListObj.OPTION_LIST_DESC,
            STATUS_ID:        1,
            WEIGHT:           optionListObj.WEIGHT,                
            LANG_PT:          optionListObj.LANG_PT,
            LANG_EN:          optionListObj.LANG_EN,
            LANG_ES:          optionListObj.LANG_EN,
            ITEMS_LIST:       []
        };
        let data = await updateOptionList(sendedData);
        if (data) {
            if (data?.status?.statusCode == 0) {
                data = data.response.content;
                handleChange({ OPTION_LIST_ID: parseInt(data.OPTION_LIST_ID) });
                setListLoading(false);
            }
            else {
                setListLoading(false);
                showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
            }
        }
    };

    const handleChange = (updatedValues) => {
        const mergedValues = {
            ...optionListObj,
            ...updatedValues
        };
    
        if (
            mergedValues.LANG_PT === "N" &&
            mergedValues.LANG_EN === "N" &&
            mergedValues.LANG_ES === "N"
        ) {
            showInfoMessage({
                header: GetLabel(appLang, 54),
                message: GetLabel(appLang, 183)
            });
            // Stop update if invalid
            return; 
        }
    
        setOptionListObj(mergedValues);
    };

    const BtnSave = () => {
        if (validateRecord(optionListObj)) {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: GetLabel(appLang, 184) },
                { confirm_action: () => handleSave()}
            );
            return;
        }
        else {
            showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 185)}<br/>{GetLabel(appLang, 186)}<br/>{GetLabel(appLang, 187)}</>});
            return;
        }
    };

    const BtnDelete = () => {
        for (var i = 0; i < optionListObj.ITEMS_LIST.length; i++) {
            if (optionListObj.ITEMS_LIST[i].IsLoading === true) {
                showInfoMessage({header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 188)}</>});
                return;
            }
        }
        showActionMessage(
          { header: GetLabel(appLang, 54), message: GetLabel(appLang, 189) },
          { confirm_action: () => handleDelete()}
        );
    };

    useEffect(() => {
        const fetchData = async (list_id) => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getOptionListByID(list_id);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            for (var i  = 0; i < fetchedData.ITEMS_LIST.length; i ++) {
                                fetchedData.ITEMS_LIST[i].IsEditing = false;
                                fetchedData.ITEMS_LIST[i].IsLoading = false;
                            }
                            setOptionListObj(fetchedData || blank_option_list_obj);
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setOptionListObj(blank_option_list_obj);
            }
        };
        if (data?.OPTION_LIST_ID && data.OPTION_LIST_ID !== 0) {
            fetchData(data.OPTION_LIST_ID);
        } 
        else {
            setOptionListObj(blank_option_list_obj);
        }
    }, [data]);

    return(
        <>
            <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
                <div className={MainStyle.mt_3}/>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_1}>                            
                    </div>
                    <div className={MainStyle.col_11}>
                        <div className={[MainStyle.text_end, MainStyle.mx_3].join(" ")}>
                            {<BtnCloseAction click_action={BtnExit}/>}
                        </div>
                    </div>
                </div>
                <div className={MainStyle.mt_3}/>


                <div className={[MainStyle.bg_card_inner,
                                 MainStyle.border_top,
                                 MainStyle.border_bottom,
                                 MainStyle.border_end].join(" ")}>

                    <div className={MainStyle.mt_5}/>
                    {/*             Option List Description             */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_5}>
                            <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                <span className={[MainStyle.fs_6,
                                                  MainStyle.text_body,
                                                  MainStyle.fw_semibold
                                                ].join(" ")}
                                >
                                    {GetLabel(appLang, 190)}*:
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_5}>
                            <div className={MainStyle.mx_3}>
                                <InputGeneral 
                                    value={optionListObj.OPTION_LIST_DESC}
                                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                    onChange={(event) => handleChange({ OPTION_LIST_DESC: q3x_FunData(event.target.value) })}
                                    placeholder={GetLabel(appLang, 191)}
                                    maxLength={150}
                                />
                                <span className={[MainStyle.ms_2, MainStyle.text_body_faded, MainStyle.fs_8].join(" ")}>{optionListObj.OPTION_LIST_DESC.length} {GetLabel(appLang, 44)} 150 {GetLabel(appLang, 45)}.</span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>
                    
                    {DavidCopperfield(8,89,4) && (
                        optionListObj.OPTION_LIST_ID == 0 ?
                            <div className={[MainStyle.row, MainStyle.my_3, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_lg_9}></div>
                                <div className={MainStyle.col_lg_2}>
                                    <div className={[MainStyle.mt_3].join(" ")}>
                                        <div
                                            className={[MainStyle.d_flex,
                                                        MainStyle.justify_content_center,
                                                        MainStyle.btn_green, 
                                                        MainStyle.rounded_3, 
                                                        MainStyle.border, 
                                                        MainStyle.shadow_sm,
                                                        MainStyle.py_3,
                                                        MainStyle.px_3,
                                                        MainStyle.mx_3].join(" ")}
                                            onClick={() => {SaveList()}}
                                        >
                                            {
                                                listLoading ?
                                                    <div style={{zIndex: '1'}} className={[MainStyle.mx_3, MainStyle.text_white].join(" ")}>
                                                        <div className={[MainStyle.small_loading_circle_white].join(" ")}/>
                                                    </div>
                                                :
                                                    null

                                            }                                        
                                            <span className={[MainStyle.fs_6, MainStyle.text_white,].join(" ")}>
                                                {GetLabel(appLang, 192)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className={MainStyle.col_lg_1}/>
                            </div>
                        :
                            null
                    )}

                    {/*                 Division Block                 */}
                    <div className={[MainStyle.py_2].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_1}/>
                            <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                            <div className={MainStyle.col_lg_1}/>
                        </div>
                    </div>

                    {/*             Option List PT Lang                 */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            
                            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 193)}: 
                                        </span>
                                    </div>
                                </div>      
                                <div className={[MainStyle.col_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 200)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className={MainStyle.col_6}>
                                    <div className={MainStyle.ms_3}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={optionListObj.LANG_PT === "Y" ? true : false}
                                            onChange={()=> {optionListObj.LANG_PT === "N"? handleChange({ LANG_PT: 'Y' }) : handleChange({ LANG_PT: 'N' })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                 Division Block                 */}
                    <div className={[MainStyle.py_2].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_1}/>
                            <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                            <div className={MainStyle.col_lg_1}/>
                        </div>
                    </div>

                    {/*             Option List EN Lang                 */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            
                            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 194)}: 
                                        </span>
                                    </div>
                                </div>      
                                <div className={[MainStyle.col_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 201)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className={MainStyle.col_6}>
                                    <div className={MainStyle.ms_3}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={optionListObj.LANG_EN === "Y" ? true : false}
                                            onChange={()=> {optionListObj.LANG_EN === "N"? handleChange({ LANG_EN: 'Y' }) : handleChange({ LANG_EN: 'N' })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                 Division Block                 */}
                    <div className={[MainStyle.py_2].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_1}/>
                            <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                            <div className={MainStyle.col_lg_1}/>
                        </div>
                    </div>

                    {/*             Option List ES Lang                 */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            
                            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 195)}: 
                                        </span>
                                    </div>
                                </div>      
                                <div className={[MainStyle.col_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 202)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className={MainStyle.col_6}>
                                    <div className={MainStyle.ms_3}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={optionListObj.LANG_ES === "Y" ? true : false}
                                            onChange={()=> {optionListObj.LANG_ES === "N"? handleChange({ LANG_ES: 'Y' }) : handleChange({ LANG_ES: 'N' })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    {/*                 Division Block                 */}
                    <div className={[MainStyle.py_2].join(" ")}>
                        <div className={MainStyle.row}>
                            <div className={MainStyle.col_lg_1}/>
                            <div className={[MainStyle.col_lg_10, MainStyle.border_bottom].join(" ")}/>
                            <div className={MainStyle.col_lg_1}/>
                        </div>
                    </div>

                    {/*             Option List Weight                  */}
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_1}/>
                        <div className={MainStyle.col_lg_10}>
                            
                            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                                <div className={MainStyle.col_5}>
                                    <div className={[MainStyle.text_start, MainStyle.ms_3].join(" ")}>
                                        <span className={[MainStyle.fs_6, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                                            {GetLabel(appLang, 196)}: 
                                        </span>
                                    </div>
                                </div>      
                                <div className={[MainStyle.col_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {showInfoMessage({'header': GetLabel(appLang, 199), 'message': GetLabel(appLang, 203)});}}>
                                        <svg viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className={MainStyle.col_6}>
                                    <div className={MainStyle.ms_3}>
                                        <input
                                            type="checkbox"
                                            name={"read"}
                                            checked={optionListObj.WEIGHT === "Y" ? true : false}
                                            onChange={()=> {optionListObj.WEIGHT === "N"? handleChange({ WEIGHT: 'Y' }) : handleChange({ WEIGHT: 'N' })}}
                                            style={{ transform: "scale(1.5)" }}
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className={MainStyle.col_lg_1}/>
                    </div>

                    <div className={MainStyle.py_3}/>
                    {   /*             Items Label + btn New + items       */
                        optionListObj.OPTION_LIST_ID != 0 ?
                            <OptionList mainObject={optionListObj} setMainObject={setOptionListObj}/>   
                        :
                            null
                    }

                    <div className={MainStyle.py_3}/>
                </div>
                
                <div className={MainStyle.my_5}/>

            </div>
            {/*--------------------------------------------------------------------------*/}            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_7}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(8,89,6) && (
                        optionListObj.OPTION_LIST_ID != 0 ? 
                            <div className={[MainStyle.mt_3].join(" ")}>
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_delete, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={() => {BtnDelete()}}
                                >
                                    {GetLabel(appLang, 114)}
                                </button>
                            </div>
                    : 
                        null
                    )}
                </div>
                <div className={MainStyle.col_lg_1}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(8,89,4) && (
                        <div className={[MainStyle.mt_3].join(" ")}>
                            {
                                optionListObj.OPTION_LIST_ID != 0 ?
                                <button
                                    style={{width: '100%'}}
                                    className={[MainStyle.btn_green, 
                                                MainStyle.rounded_3, 
                                                MainStyle.border, 
                                                MainStyle.shadow_sm, 
                                                MainStyle.fs_6,
                                                MainStyle.text_white,
                                                MainStyle.py_3,
                                                MainStyle.px_3].join(" ")}
                                    onClick={BtnSave}
                                >
                                    {GetLabel(appLang, 49)}
                                </button>
                                :
                                null
                            }
                        </div>
                    )}
                </div>
            </div>
            {/*--------------------------------------------------------------------------*/}                                    
        </>
    );

};

const OptionListTableGrid = ({setProps}) => {
    const [ isLoading,  setIsLoading]            = useState(false);   // Loading fetch control
    const { showLoader, hideLoader }             = useLoader();       // Control over the  
    const [searchText,  setSearchText]           = useState('');      // Searched text state
    const [rowData,     setRowData]              = useState([]);      // State of rows def 
    const [columnDefs,  setcolumnDefs]           = useState([]);      // State of columns def
    const gridRef                                = useRef();
    const { showInfoMessage }                    = useInfoMsgModal(); // Modal message control 

    ModuleRegistry.registerModules([AllCommunityModule]);

    const gridOptions = {
        pagination: true, // Enable pagination
        paginationPageSize: 20, // Number of rows per page
        localeText: GetAppLang() === "PT" ? AG_GRID_LOCALE_BR : null,
        suppressHorizontalScroll: false,
        embedFullWidthRows: true,
        groupSuppressBlankHeader: false,
        enableCellTextSelection: true
    };

    const EditItem = (props) => {
        const handleData = () => {
            let obj_copy = JSON.parse(JSON.stringify(blank_option_list_obj));
            obj_copy.OPTION_LIST_ID = props.data.OPTION_LIST_ID;
            setProps({ setScreen: 2, data: obj_copy });
        };
        return(
            <>
                <div 
                    onClick={() => {handleData()}} 
                    className={[MainStyle.table_btn_icon, MainStyle.shadow_sm, MainStyle.p_1, MainStyle.text_center].join(" ")}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"
                        className={[MainStyle.small_ico_generic].join(" ")}
                    >
                        <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                    </svg>
                </div>
            </>
        );
    };

    const defaultCol = [
        DavidCopperfield(8,89,4) && {
          headerName: GetLabel(appLang, 115),
          field: 'editar',
          cellRenderer: EditItem,
          cellClass: [MainStyle.table_text_center].join(" "), 
          headerClass: MainStyle.table_header_center,
          flex: 0,
        },
        { headerName: GetLabel(appLang, 34),  field: "OPTION_LIST_ID"     ,filter: true , flex: 0, headerClass: MainStyle.table_header_center, cellClass: [MainStyle.table_text_center].join(" "),}    ,    
        { headerName: GetLabel(appLang, 197), field: "OPTION_LIST_DESC"   ,filter: true , flex: 1,}    ,
        { headerName: GetLabel(appLang, 118), field: "UPDATED"            ,filter: true , cellRenderer: DisplayGridDatetime, flex: 0,}    ,
    ].filter(Boolean);

    const onQuickFilterChanged = (e) => {
        setSearchText(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!isLoading) {
                setIsLoading(true);
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let data = await getOptionLists(1);
                if (data) {
                    if (data?.status?.statusCode == 0) {
                        data = data.response.content;
                        setcolumnDefs(defaultCol);
                        let arr = [];
                        for(var j = 0; j < data.length; j++) {
                            arr.push(data[j]);
                        }
                        setRowData(arr);
                        hideLoader();
                        setIsLoading(false);
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        };
        fetchData();
    },[]);

    return (
        <>
        <div className={[MainStyle.bg_card, MainStyle.shadow, MainStyle.border, MainStyle.rounded].join(" ")}>
            <div className={[MainStyle.px_2, MainStyle.mt_3].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_9}></div>
                    <div className={MainStyle.col_lg_3}>
                        <div className={[MainStyle.d_flex].join(" ")}>
                            <div className={[MainStyle.mt_2, MainStyle.me_2].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 512 512"
                                    className={MainStyle.small_ico_search_bar}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
                                </svg>
                            </div>
                            <InputGeneral 
                                value={searchText}
                                className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mb_3].join(" ")} 
                                onChange={onQuickFilterChanged}
                                placeholder={GetLabel(appLang, 33)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ height: '40rem'}}>
                <AgGridReact 
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    gridOptions={gridOptions}
                    quickFilterText={searchText}
                />
            </div>
        </div>
    </>);
};

export const OptionListPage = () => {
    const [ screenType, setScreenType ]       = useState(1);
    const [ defaultData, setDefaultData]      = useState({});
    const navigate                            = useNavigate();    

    const BtnNew = () => {
        handleChange({ setScreen: 2,data: blank_option_list_obj });
    };

    const handleChange = ({ setScreen, data }) => {
        setDefaultData({ ...data });
        setScreenType(setScreen);
    };

    useEffect(() => {
        if (!Heimdall([8])) {
            navigate('/home');
        }
        else {
            SetLastFeature(8);
        }              
    }, [screenType, defaultData]);

    return (
        <>
        {
        screenType == 1? 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 198)}
                </p>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_10}></div>
                <div className={MainStyle.col_lg_2}>
                    {DavidCopperfield(8,89,0) && (
                        <div className={[MainStyle.mx_3].join(" ")}>
                            <button
                                style={{width: '100%'}}
                                className={[MainStyle.btn_blue, 
                                            MainStyle.rounded_3, 
                                            MainStyle.border, 
                                            MainStyle.shadow_sm, 
                                            MainStyle.fs_6,
                                            MainStyle.text_white,
                                            MainStyle.py_3,
                                            MainStyle.px_5].join(" ")}
                                onClick={BtnNew}
                            >
                                {GetLabel(appLang, 120)}
                            </button>
                        </div>
                    )}
                </div>
            </div>            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_12}>
                    <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                        <OptionListTableGrid setProps={handleChange}/>
                    </div>
                </div>
            </div>
            <div className={MainStyle.pb_3}></div>
        </>
        : 
        <>
            <div>
                <p className={[MainStyle.fs_4, MainStyle.mx_3, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                    {GetLabel(appLang, 198)}
                </p>
            </div>
            <div className={[MainStyle.mx_3, MainStyle.my_3].join(" ")}>
                <OptionListEditPanel setProps={handleChange} data={defaultData} />
            </div>
        </>
        }
        </>
    );
};